<template>
  <div class="ui-dropdown-columns-item" :class="mainClasses">
    <Bars3Icon v-if="!disallowDrag" class="ui-dropdown-columns-item__handle" :class="{ 'handle': modelValue }" />
    <div class="ui-dropdown-columns-item__title">
      {{ item.label }}
    </div>
    <UICheckbox v-model="modelValue" :disabled="item.disabled" />
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import { DropdownColumnsData } from '@types'

import { Bars3Icon } from '@heroicons/vue/24/outline'
import { UICheckbox } from '@ui/controllers'

type Props = {
  item: DropdownColumnsData
  disallowDrag?: boolean
}

const props = defineProps<Props>()

const modelValue = defineModel<boolean>({ default: false })

const mainClasses = computed(() => ({
  'ui-dropdown-columns-item--undragable': props.disallowDrag
}))
</script>

<style scoped>
.ui-dropdown-columns-item {
  @apply flex items-center;
  @apply gap-2 px-2 py-1;
  @apply border dark:border-gray-600 rounded;
  @apply text-sm sm:text-xs;
  @apply text-common-text;

  &__handle {
    @apply w-4 h-4;
    @apply opacity-10;

    &.handle {
      @apply opacity-100;
      @apply cursor-move;
    }
  }

  &--undragable {
    @apply !border-transparent;
  }

  &__title {
    @apply flex-auto;
    @apply truncate;
  }
}
</style>
